import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHeart, faComments } from '@fortawesome/free-solid-svg-icons';
import { faLinkedin, faFacebook, faYoutube } from '@fortawesome/free-brands-svg-icons';
import { useAuth } from '../../hooks/useAuth';
import { useTranslation } from 'react-i18next';
import FeedbackModal from "@/components/Feedback/FeedbackModal.tsx";

const Footer: React.FC = () => {
    const { user } = useAuth();
    const { t } = useTranslation();
    const [showFeedbackModal, setShowFeedbackModal] = useState(false);

    const socialLinks = [
        { name: 'Facebook', icon: faFacebook, href: 'https://www.facebook.com/buitientuan' },
        { name: 'YouTube', icon: faYoutube, href: 'https://www.youtube.com/@tuanbuitien0820' },
        { name: 'LinkedIn', icon: faLinkedin, href: 'https://www.linkedin.com/in/tu%C3%A2n-b%C3%B9i-ti%E1%BA%BFn-2261a7148' },
    ];

    return (
        <>
            <footer className="glass-footer">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
                    <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
                        {/* Brand */}
                        <div className="flex items-center space-x-3">
                            <Link to="/" className="flex items-center space-x-3">
                                <div className="flex items-center justify-center">
                                    <img src="/images/logo192.png" className="w-8 h-8"/>
                                </div>
                                <h3 className="text-lg font-bold bg-gradient-to-r from-blue-600 to-purple-600 bg-clip-text text-transparent">
                                    {t('app.name')}
                                </h3>
                            </Link>
                        </div>

                        {/* Center - Quick Links */}
                        <div className="flex items-center space-x-6">
                            {/* Social Links */}
                            <div className="flex space-x-4">
                                {socialLinks.map((social) => (
                                    <a
                                        key={social.name}
                                        href={social.href}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="text-gray-400 hover:text-gray-600 dark:hover:text-gray-300 transition-colors"
                                        title={social.name}
                                    >
                                        <FontAwesomeIcon icon={social.icon} className="w-5 h-5" />
                                    </a>
                                ))}
                            </div>

                            {/* Feedback Button - Only for logged users */}
                            {user && (
                                <button
                                    onClick={() => setShowFeedbackModal(true)}
                                    className="flex items-center px-3 py-2 text-sm font-medium text-gray-600 dark:text-gray-400 hover:text-blue-600 dark:hover:text-blue-400 hover:bg-gray-100 dark:hover:bg-gray-800 rounded-lg transition-colors"
                                    title={t('footer.feedback')}
                                >
                                    <FontAwesomeIcon icon={faComments} className="mr-2" />
                                    {t('footer.feedback')}
                                </button>
                            )}
                        </div>

                        {/* Copyright */}
                        <div className="flex items-center space-x-2 text-sm text-gray-600 dark:text-gray-400">
                            <span>{t('footer.copyright')}</span>
                            <FontAwesomeIcon icon={faHeart} className="text-red-500"/>
                            <span>{t('footer.by')}</span>
                        </div>
                    </div>
                </div>
            </footer>

            {/* Feedback Modal */}
            <FeedbackModal
                isOpen={showFeedbackModal}
                onClose={() => setShowFeedbackModal(false)}
            />
        </>
    );
};

export default Footer;